export const characterPriority = [
    "mechalizard",
    "pepe",
    "skeptic",
    "furiewitch",
    "pumpkinhead",
    "pirate",
    "skull",
    "babygirl"
]

export const cityConfig = {
    seed: 'city-004',
    blocksX: 3,
    blocksZ: 2,
    blockSize: 77,
    streetWidth: 22,
    sidewalkWidth: 5,
    streetNames: {
        vertical: ['Main St', 'Blockchain Blvd', 'Rodeo Dr', 'Maple Dr'],  // North-South streets (Z+ = North)
        horizontal: ['1st St', 'Nexus Ave', 'Squid St', '4th St', '5th St']  // East-West streets (X+ = East)
    },
    buildingDensity:.77, // Building density from 0 (empty) to 1 (completely full)
    buildingSpacing: 3, // Building spacing in world units (0 = no spacing, higher = more spacing)
    windowDensity: 0.11, // Window density from 0 (no windows) to 1 (fully windowed)
    blockTypes: {
        "0,0": {
            type: "cyberpunk",
            name: "finance_tower"
        },  
        "1,0": {
            type: "park",
            name: "park_central"
        },
        "2,0": {
            type: "cyberpunk",
            name: "cyberpunk_corner"
        },
        "0,1": {
            type: "gotham",
            name: "gotham_tower",
            buildingPriority: [{
                corner: "se",
                size: "xl",
            }],
        },
        "1,1": {
            type: "gotham",
            name: "cyberpunk_art",
            buildingDensity: .84
        },
        "2,1": {
            type: "gotham",
            name: "brains_hq"
        },
    }
}

// Door styles and tones
export const doorStyles = {
    glass_door: {
        material: 'glass',
        opacity: 0.7,
        reflectivity: 0.8,
        thickness: 0.1,
        frame: 'metal'
    },
    metal_door: {
        material: 'metal',
        opacity: 1.0,
        reflectivity: 0.3,
        thickness: 0.2,
        frame: 'metal'
    },
    wooden_door: {
        material: 'wood',
        opacity: 1.0,
        reflectivity: 0.1,
        thickness: 0.15,
        frame: 'wood'
    },
    security_door: {
        material: 'metal',
        opacity: 1.0,
        reflectivity: 0.5,
        thickness: 0.3,
        frame: 'metal',
        reinforced: true
    }
};

export const doorTones = {
    blue: { color: '#4A90E2', emissive: '#1A4A7A', intensity: 0.3 },
    steel: { color: '#708090', emissive: '#2F4F4F', intensity: 0.2 },
    bronze: { color: '#CD7F32', emissive: '#8B4513', intensity: 0.25 },
    chrome: { color: '#C0C0C0', emissive: '#696969', intensity: 0.4 },
    black: { color: '#2C2C2C', emissive: '#000000', intensity: 0.1 },
    white: { color: '#F5F5F5', emissive: '#D3D3D3', intensity: 0.2 }
};

// Window decorations configuration
export const decorations = {
    "cyberpunk_art": {
        // "building_a": {
        //     windows: { 
        //         north: { type: "tech_store", tone: "blue", scale: 1.0, offset: { x: 0, y: 0 } },
        //         south: { type: "coffee_shop", tone: "warm", count: 2, scale: 1.0, offset: { x: 0.1, y: -0.2 } }
        //     }
        // },
        // "building_b": {
        //     windows: { 
        //         south: { type: "tech_store", tone: "blue", vibrance: .33, count: 2, gap: 1, scale: 2, offset: { x: 0, y: 3} }
        //     }
        // },
        
        "building_a": {
            windows: {
                south: { type: "tech_store", tone: "blue", count: 2,scale: 1.0, offset: { x: 0, y: 0 } }
            },
            murals: {
                south: {
                    type: "mural",
                    url: [
                        require("../media/art/furie_fullwall.jpg"),
                        require("../media/art/aeron_city.jpg"),
                        require("../media/art/retro1.jpg"),
                        require("../media/art/spider_comic.jpg"),
                        require("../media/art/ufo_art.jpg"),
                        require("../media/art/red_monster.jpg"),
                        require("../media/art/blue_monster.jpg"),
                        require("../media/art/dragon_lasers.jpg"),
                        require("../media/art/eyes_nose.jpg"),
                        require("../media/art/dragon_lighthouse.jpg"),
                      
                    ],
                    muralDuration: 10000,
                    transitionType: "pixel",
                    colorBarNoise: 1,
                    transitionSpeed: 1.0,
                    transitionTime: 3000,
                    pixelSize: 4,
                    pixelMode: false,
                    rotation: [0, 0, 0],
                    scale: 1.0,
                    anchor: "bottom",
                    mode: "cover",
                    padding: 1,
                    aspectRatio: 1.5,
                    offset: { x: 0, y: 0 },
                    brightness: 1,
                }
            }
        },
        "building_d": {
            windows: { 
                south: { type: "coffee_shop", tone: "warm", vibrance: .11, anchor: "left",count: 2, scale: 1.4, offset: { x: -2, y: 1 } }
            }
        }
    },
    "gotham_tower": {
        "building_f": {
            windows: { 
                south: { type: "tech_store", tone: "blue", anchor: "center",count: 2, vibrance: .22, scale: 1.7, offset: { x: 0, y: 5 } },
                east: { type: "tech_store", tone: "blue", anchor: "center",count: 2, vibrance: .22, scale: 1.7, offset: { z: 9,x: 0, y: 5 } },
            },
            doors: {
                east: { type: "metal_door", tone: "steel", anchor: "left", count: 2, vibrance: .3, scale: 1.3, gap: .1,offset: { z: 0, x: 0, y: 0 } },
                south: { type: "metal_door", tone: "steel", anchor: "center", count: 1, vibrance: .4, scale: 1.3, offset: { x: 0, y: 0 } },
            },
            signs: {
                south: {
                    type: "metal_sign",
                    url: require("../components/3d/objects/boys_club_neon.glb"),
                    anchor: "right",
                    offset: { z: 0, x: -7, y: 17 },
                    scale: 3.7,
                    emmissiveIntensity: 1,
                    vibrance: 1,
                    // glowColor: "#00ffff",
                    signTone: null,
                    logoTone: "#00ffff",
                    logoToneIntensity: 1.4,
                }
            },
            // signs removed to avoid heavy operations
        }
    },
    "finance_tower": {
        // "building_a": {
        //     windows: { 
        //         south: { type: "car_dealership", tone: "neon", scale: 1.0, offset: { x: -0.1, y: 0 } }
        //     }
        // },

        "building_e": {
            windows: { 
                east: { type: "coffee_shop", tone: "red", vibrance: .11, anchor: "left",count: 2, scale: .8, offset: { x: 0, y: 1 } },
                south: { type: "coffee_shop", tone: "blue", vibrance: .11, anchor: "center",count: 4, scale: 1, offset: { x: 0, y: 14 } }
            },
            murals: {
                south: {
                    type: "mural",
                    url: require("../media/art/aeron_wall.jpg"),
                    rotation: [0, 0, 0],
                    scale: 1.0,
                    anchor: "bottom",
                    mode: "cover",
                    padding: 1,
                    aspectRatio: 1.5,
                    offset: { x: 0, y: 0 },
                    brightness: .33,
                }
            }
        }
    },
    "brains_hq": {
        "building_a": {
            windows: { 
                south: { type: "tech_store", tone: "red", anchor: "left",count: 2, vibrance: .07, scale: 1.0, offset: { x: 0, y: 5 } },
                // west: { type: "coffee_shop", tone: "warm", scale: 1.0, offset: { x: 0, y: 0 } }
            },
            // signs: {
            //     west: {
            //         type: "metal_sign",
            //         url: require("../components/3d/objects/uniswap.glb"),
            //         anchor: "left",
            //         offset: { z: 7, x: 7, y: 33 },
            //         scale: 2.5,
            //         emmissiveIntensity: 1,
            //         vibrance: 1,
            //         // glowColor: "#00ffff",
            //         signTone: null,
            //         logoTone: "#ff007a",
            //         logoToneIntensity: 1.4,
            //     }
            // },
        }
    }
}





export const introConfig = {
    introLines: [
        "In the wake of the Blockchain Wars,",
        "the sky flickered with corrupted light.",
        "The old gods of signal fell,",
        "their voices dissolved in static.",
        "",
        "Echoes spoke of a refuge,",
        "where the exiled recompile.",
        "",
        "A passage between spheres,",
        "amongst the forgotten.",
        "",
        "We are Monster Brains.",

    ],
    lineDuration: 3000,
}


export const sceneConfig = {
    camPos: [0, 20, 0], // Default camera position for LOD calculations
    sceneTransitionType: "fade", //  fade or zoom
    sceneTransitionDuration: 1000,
    steadyCam: {
       
        "sceneone": {
            startPosition: [20, 40, -90],
            startRotation: [-2.95,-.33,Math.PI],
            startFov: 75,
            targetPosition: [-44,33, -80],
            targetRotation: [-3.1,.2,Math.PI],
            targetFov: 75,
            transitionDuration: 110000,
            transitionType: "linear",
            transitionEasing: "easeInOut",
            transitionDelay: 0,
            transitionLoop: false,
            transitionLoopDelay: 0,
            transitionLoopType: "linear",
            transitionLoopEasing: "easeInOut",
            loop: true,
        },
        "scenefour": {
            startPosition: [64,14,1],
            startRotation: [0,Math.PI/2,0],
            startFov: 75,
            targetPosition: [22,33,-8],
            targetRotation: [-.3,Math.PI/2,0],
            targetFov: 75,
            transitionDuration: 110000,
        },
        "scenethree": {
            startPosition: [41,71,-18],
            startRotation: [-2.9,-.7,3],
            startFov: 75,
            targetPosition: [-3,70,-57],
            targetRotation: [-2.7,.2,Math.PI],
            targetFov: 75,
            transitionDuration: 110000,
        },
        "scenetwo": {
            startPosition: [-4, 70, -64],
            startRotation: [-2.7,0,3],
            startFov: 75,
            targetPosition: [40,127,-45],
            targetRotation: [-1.7,0,-3.35],
            targetFov: 75,
            transitionDuration: 110000,
        },
        "scenefive": {
            startPosition: [0,11,-44],
            startRotation: [0,-Math.PI,0],
            startFov: 75,
            targetPosition: [0,11,-33],
            targetRotation: [.2,-Math.PI,0],
            targetFov: 75,
            transitionDuration: 110000,
        },
       
        // "scenetwo": {
        //     startPosition: [-20, 22, -70],
        //     startRotation: [-2.95,-.13,Math.PI],
        //     startFov: 75,
        //     targetPosition: [-11,27, -44],
        //     targetRotation: [-3.1,-.2,Math.PI],
        //     targetFov: 75,
        //     transitionDuration: 11000,
        //     transitionType: "linear",
        //     transitionEasing: "easeInOut",
        //     transitionDelay: 0,
        //     transitionLoop: false,
        //     transitionLoopDelay: 0,
        //     transitionLoopType: "linear",
        //     transitionLoopEasing: "easeInOut",
        //     loop: true,
        // }
    },
    groundCamera: {
        position: [-10, 40, -90], // Ground level where UFO beam hits
        rotation: [-2.95,0,Math.PI], // Initial rotation from sceneConfig
        fov: 75
    }
}


